import { reactive, toRefs, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

type State = {
  route: any
}

const useRouterHook = () => {
  const route = useRoute() // Access the current route
  const router = useRouter() // Access the router instance

  const state = reactive<State>({
    route
  })

  // Watch for route changes and update state
  watch(
    () => route, // Dependency on the route
    (newRoute) => {
      state.route = newRoute // Update the state when the route changes
    }
  )

  return { ...toRefs(state), router }
}

export default useRouterHook
